/**
 * Decodes a base64 string with proper UTF-8 support.
 * Unlike atob() which produces Latin-1, this correctly handles
 * multi-byte UTF-8 characters (e.g. é, è, ê).
 */
export function decodeBase64Utf8(base64: string): string {
  const binaryString = atob(base64)
  const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0))
  return new TextDecoder('utf-8').decode(bytes)
}

/**
 * Sends a command to EfficienceWeb via postMessage
 */
export function sendEfficienceCommand(iframe: HTMLIFrameElement, xmlCommand: string) {
  const base64Request = btoa(xmlCommand)
  iframe.contentWindow?.postMessage(
    JSON.stringify({
      remoteCommand: base64Request,
    }),
    '*'
  )
}
